import { render, staticRenderFns } from "./AssetEditorLimited.vue?vue&type=template&id=329174fe&"
import script from "./AssetEditorLimited.vue?vue&type=script&lang=js&"
export * from "./AssetEditorLimited.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports